import React from "react";
import { VideoTag } from "../common/VideoTag";
import { isMobileOnly } from "react-device-detect";
import { siteUrl } from "../../utils/constants";
import { mediaUrl } from "../../utils/imageUtils";

interface VideoFullWidthProps {
  url?: string;
  elementId?: string;
}

const VideoFullWidth: React.FC<VideoFullWidthProps> = ({
  url,
  elementId = "",
}) => (
  <>
    <div id={elementId}>
      <div className="bkg">
        {isMobileOnly ? (
          <VideoTag
            autoPlay="true"
            muted="true"
            playsInline="true"
            loop="true"
            src={mediaUrl(url)}
          />
        ) : (
          <video className="vid" autoPlay muted loop playsInline>
            <source src={mediaUrl(url)} type="video/mp4" />
          </video>
        )}
      </div>
    </div>
  </>
);

export default VideoFullWidth;
